import React from 'react'
import AdminComponent from '../../components/admin/AdminComponent'

const AdminPage = () => {
  return (
    <>
        <AdminComponent />
    </>
  )
}

export default AdminPage